
  import Vue from 'vue';
  import {mapState, mapMutations} from 'vuex';
  import * as VuexMutation from '@/store/mutation-types';
  import {library} from '@/models/library';

  export default Vue.extend({
    name: 'App',
    components: {
      Queue: () => import ('@/components/Queue.vue'),
      Player: () => import ('@/components/Player.vue'),
      Config: () => import ('@/components/Config.vue'),
      MessageTray: () => import ('@/components/MessageTray.vue'),
      SharedPlayer: () => import ('@/components/SharedPlayer.vue'),
     },
    data() {
      return {
        library: library,
        player: false,
        sharedPlayer: true,
      }
    },
    computed: {
      ...mapState(['playingTrack', 'searchQuery']),
      query: {
        get(): string {
          return this.searchQuery;
        },
        set(query: string) {
          this.setSearchQuery(query);
        }
      },
      routerPath(): string {
        return this.$route.path;
      },
      urlQuery(): object {
        return this.$route.query;
      }
    },
    methods: {
      ...mapMutations({
        setSearchQuery: VuexMutation.SET_SEARCH_QUERY,
      }),
      togglePlayer() {
        this.player = !this.player;
      },
      toggleSharedPlayer() {
        this.sharedPlayer = !this.sharedPlayer;
      }
    },
    watch: {
      playingTrack() {
        this.player = this.playingTrack !== null;
      }
    }
  });
